import React, { useState } from "react";
import Layout from "../../Shared/Layout";
import {
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import Collapse from "@mui/material/Collapse";
import styled from "styled-components";
import { Inertia } from "@inertiajs/inertia";
import MuiButton from "@material-ui/core/Button";
import { Field, Form as FinalForm } from "react-final-form";
import TextInput from "../../Shared/TextInput";
import { getCookieValue } from "../../utils/getCookieValue";
import { Trans } from "../../utils/i18n";
import DeleteIcon from "@material-ui/icons/Delete";
import { Alert } from "@material-ui/lab";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Wrapper from "./Wrapper";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Select from "../../Shared/Select";
import Checkbox from "../../Shared/Checkbox";

const HR = styled.hr`
    display: flex;
    justify-content: flex-end;
    margin: 15px 0;
`;

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

const FieldWrapper = styled.div`
    margin-bottom: 10px;
`;

export default function RepairParts({
    client,
    order,
    statuses,
    services,
    partners,
    coverages,
    settlements,
    materialOperations,
    files,
    userCanUpdate,
    orderattributes,
    orderhistories,
    extendedMode,
    permissions,
    returnUrl,
    QUOTATION_STATUS_PAID,
    QUOTATION_STATUS_REJECTED,
    QUOTATION_STATUS_PENDING,
    products,
    orderDetailMaterials,
    repairCodes,
}) {
    const [_orderDetailMaterials, setOrderDetailMaterials] =
        React.useState(orderDetailMaterials);
    const [errorMessage, setErrorMessage] = React.useState(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const initialPart = {
        product_id: null,
        product_number: "",
        product_description: "",
        quantity: 1,
        repaircode: "",
        repaircode_text: "",
        on_hold: "No",
    };

    const onSubmitPartModal = async (part, form) => {
        setErrorMessage(false);

        part.quantity = parseInt(part.quantity);
        part.on_hold = part?.on_hold == "Yes" ? true : false;

        const partFound = products.find(
            (_part, index) => part.product_id == _part.id
        );
        part.product_description = partFound?.description;
        part.product_number = partFound?.number;

        const repairCodeFound = repairCodes.find(
            (_repairCode, index) => part.repaircode_id == _repairCode.id
        );
        part.repaircode = repairCodeFound?.code;
        part.repaircode_text = repairCodeFound?.description;

        // Hide Modal
        setIsModalOpen(false);
        // Set Quotation Parts
        setOrderDetailMaterials([..._orderDetailMaterials, part]);

        form.restart(initialPart);
    };

    const deletePart = (partIndex) => {
        const parts = Array.from(_orderDetailMaterials).filter(
            (part, index) => partIndex !== index
        );

        setOrderDetailMaterials(parts);
    };

    const onSaveRepairParts = async () => {
        setErrorMessage(false);

        await fetch(
            route("orderdetailmaterials.store", [order.orderdetail_id]),
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify({
                    orderDetailMaterials: _orderDetailMaterials,
                }),
            }
        )
            .then((res) => res.json())
            .then((response) => {
                if (response.success) {
                    window.location.reload();
                } else {
                    setErrorMessage(response.message);
                }
            })
            .catch(() => {
                // TODO
            });
    };

    const handleCloseModal = (form) => {
        form.restart(initialPart);
        setIsModalOpen(false);
    };

    return (
        <Wrapper>
            <FinalForm initialValues={order} onSubmit={onSaveRepairParts}>
                {({
                    handleSubmit,
                    submitting,
                    values,
                    form,
                    errors,
                    touched,
                }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <HR />
                            <h3>
                                <Trans i18nKey="queueDetail.repairParts">
                                    Repair Parts
                                </Trans>
                            </h3>
                            {order.permissions.orderdetailmaterial.create && (
                                <MuiButton
                                    variant="contained"
                                    color={"secondary"}
                                    onClick={() => {
                                        setIsModalOpen(true);
                                    }}
                                >
                                    +{" "}
                                    <Trans i18nKey="queueDetail.repairParts.addPart">
                                        Add Part
                                    </Trans>
                                </MuiButton>
                            )}

                            <ResponseWrapper>
                                <Collapse in={errorMessage}>
                                    <Alert severity="error">
                                        <Trans i18nKey="queueDetail.repairParts.someErrorOccurred">
                                            Some error occurred
                                        </Trans>
                                        . {errorMessage}!
                                    </Alert>
                                </Collapse>
                            </ResponseWrapper>

                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <Trans i18nKey="queueDetail.repairParts.product_number">
                                                    Part number
                                                </Trans>
                                            </TableCell>
                                            <TableCell>
                                                <Trans i18nKey="queueDetail.repairParts.product">
                                                    Part
                                                </Trans>
                                            </TableCell>
                                            <TableCell>
                                                <Trans i18nKey="queueDetail.repairParts.quantity">
                                                    Quantity
                                                </Trans>
                                            </TableCell>
                                            <TableCell>
                                                <Trans i18nKey="queueDetail.repairParts.repairCode">
                                                    Repair Code
                                                </Trans>
                                            </TableCell>
                                            <TableCell>
                                                <Trans i18nKey="queueDetail.repairParts.repairCodeDescription">
                                                    Repair Code Description
                                                </Trans>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Trans i18nKey="queueDetail.repairParts.onHold">
                                                    On Hold
                                                </Trans>
                                            </TableCell>
                                            {order.permissions
                                                .orderdetailmaterial.delete && (
                                                <TableCell>
                                                    <Trans i18nKey="queueDetail.repairParts.actions">
                                                        Actions
                                                    </Trans>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {_orderDetailMaterials.map(
                                            (part, index) => {
                                                return (
                                                    <TableRow
                                                        key={"tableRow" + index}
                                                    >
                                                        <TableCell>
                                                            {
                                                                part.product_number
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            {
                                                                part.product_description
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            {part.quantity}
                                                        </TableCell>
                                                        <TableCell>
                                                            {part.repaircode}
                                                        </TableCell>
                                                        <TableCell>
                                                            {
                                                                part.repaircode_text
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            {part.on_hold
                                                                ? "Yes"
                                                                : "No"}
                                                        </TableCell>
                                                        {order.permissions
                                                            .orderdetailmaterial
                                                            .delete && (
                                                            <TableCell>
                                                                <DeleteIcon
                                                                    onClick={() => {
                                                                        deletePart(
                                                                            index
                                                                        );
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                );
                                            }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <div className={'flex justify-end gap-3 mt-10'}>
                                {extendedMode && (
                                    <MuiButton
                                        variant="contained"
                                        disabled={submitting}
                                        onClick={() =>
                                            Inertia.visit(
                                                route("queue.index", {
                                                    requesttype:
                                                        order.requesttype_key,
                                                })
                                            )
                                        }
                                    >
                                        <Trans i18nKey="queueDetail.repairParts.cancel">
                                            Cancel
                                        </Trans>
                                    </MuiButton>
                                )}
                                <MuiButton
                                    variant="contained"
                                    color={"secondary"}
                                    disabled={
                                        submitting ||
                                        (!order.permissions.orderdetailmaterial
                                            .create &&
                                            !order.permissions
                                                .orderdetailmaterial.delete)
                                    }
                                    type={"submit"}
                                    onClick={() => {
                                        form.change("saveAndCloseJob", false);
                                    }}
                                >
                                    <Trans i18nKey="queueDetail.repairParts.save">
                                        Save
                                    </Trans>
                                </MuiButton>

                                <br />
                            </div>
                        </form>
                    );
                }}
            </FinalForm>
            {order.permissions.orderdetailmaterial.create && (
                <FinalForm
                    initialValues={initialPart}
                    onSubmit={onSubmitPartModal}
                >
                    {({
                        handleSubmit,
                        submitting,
                        values,
                        form,
                        errors,
                        touched,
                    }) => {
                        return (
                            <Dialog
                                open={isModalOpen}
                                onClose={() => handleCloseModal(form)}
                            >
                                <form onSubmit={handleSubmit}>
                                    <DialogTitle>
                                        <Trans i18nKey="queueDetail.repairParts.addPart">
                                            Add Part
                                        </Trans>
                                    </DialogTitle>
                                    <DialogContent>
                                        <FieldWrapper>
                                            <Field
                                                name={"product_id"}
                                                component={Select}
                                                field={{
                                                    label: (
                                                        <Trans i18nKey="queueDetail.repairParts.product">
                                                            Product
                                                        </Trans>
                                                    ),
                                                    size: "small",
                                                    options: products.map(
                                                        (product) => {
                                                            return {
                                                                value: product.id,
                                                                label: product.number + ' - ' + product.description,
                                                            };
                                                        }
                                                    ),
                                                    required: true,
                                                }}
                                                validate={(value) =>
                                                    value
                                                        ? undefined
                                                        : "Required"
                                                }
                                            />
                                        </FieldWrapper>
                                        <FieldWrapper>
                                            <Field
                                                name={"quantity"}
                                                component={TextInput}
                                                field={{
                                                    label: (
                                                        <Trans i18nKey="queueDetail.repairParts.quantity">
                                                            Quantity
                                                        </Trans>
                                                    ),
                                                    type: "number",
                                                    size: "small",
                                                }}
                                                validate={(value) =>
                                                    parseFloat(value) >
                                                    0 ? undefined : (
                                                        <Trans i18nKey="queueDetail.repairParts.gt0">
                                                            Must be greater than
                                                            0
                                                        </Trans>
                                                    )
                                                }
                                            />
                                        </FieldWrapper>
                                        {/* <FieldWrapper>
                                            <Field
                                                name={"repaircode_id"}
                                                component={Select}
                                                field={{
                                                    label: (
                                                        <Trans i18nKey="queueDetail.repairParts.repairCode">
                                                            Repair Code
                                                        </Trans>
                                                    ),
                                                    size: "small",
                                                    options: repairCodes.map(
                                                        (repairCode) => {
                                                            return {
                                                                value: repairCode.id,
                                                                label:
                                                                    repairCode.code +
                                                                    " - " +
                                                                    repairCode.name,
                                                            };
                                                        }
                                                    ),
                                                    required: true,
                                                }}
                                                validate={(value) =>
                                                    value
                                                        ? undefined
                                                        : "Required"
                                                }
                                            />
                                        </FieldWrapper> */}
                                        <FieldWrapper>
                                            <Field
                                                name={"on_hold"}
                                                component={Checkbox}
                                                field={{
                                                    label: (
                                                        <Trans i18nKey="queueDetail.repairParts.onHold">
                                                            On Hold
                                                        </Trans>
                                                    ),
                                                }}
                                                type="checkbox"
                                                value="Yes"
                                            />
                                        </FieldWrapper>
                                    </DialogContent>
                                    <DialogActions>
                                        <MuiButton
                                            variant="contained"
                                            onClick={() =>
                                                handleCloseModal(form)
                                            }
                                            className={'mr-2'}
                                            style={{ marginLeft: 15 }}
                                        >
                                            <Trans i18nKey="queueDetail.repairParts.cancel">
                                                Cancel
                                            </Trans>
                                        </MuiButton>
                                        <MuiButton
                                            variant="contained"
                                            color={"secondary"}
                                            type={"submit"}
                                            disabled={
                                                !order.permissions
                                                    .orderdetailmaterial.create
                                            }
                                        >
                                            <Trans i18nKey="queueDetail.repairParts.addPart">
                                                Add Part
                                            </Trans>
                                        </MuiButton>
                                    </DialogActions>
                                </form>
                            </Dialog>
                        );
                    }}
                </FinalForm>
            )}
        </Wrapper>
    );
}

RepairParts.layout = (page) => <Layout children={page} />;
